import {Record, type RecordOf} from 'immutable';

type Shape = {
  property: string;
  ascending: boolean;
  open: boolean;
  mint: boolean;
};

export type DynQuerySortType = RecordOf<Shape>;

// @ts-expect-error - TS2322 - Type 'Factory<{ property: string; ascending: true; open: false; mint: false; }>' is not assignable to type 'Factory<Shape>'.
export const DynQuerySort: Record.Factory<Shape> = Record(
  {
    property: '',
    ascending: true,

    // transient
    open: false,
    mint: false,
  },
  'DynQuerySort'
);
